import React from "react";
import { FormControl, FormErrorMessage, FormHelperText, FormLabel, Text } from "@chakra-ui/react";

import { getRuntimeFieldLabel } from "../RiskReviewQuestionCard";

const FieldFrame = ({ field, error, children, isRequired, compact }) => (
  <FormControl isInvalid={Boolean(error)} isRequired={isRequired}>
    {field.label ? (
      <FormLabel
        fontSize={compact ? "xs" : "sm"}
        fontWeight="semibold"
        color="gray.600"
        _dark={{ color: "gray.300" }}
        mb={compact ? 1 : 2}
        textTransform={compact ? "uppercase" : "none"}
      >
        {getRuntimeFieldLabel(field)}
      </FormLabel>
    ) : null}
    {children}
    {error?.message ? (
      <FormErrorMessage>{error.message}</FormErrorMessage>
    ) : field.helpText ? (
      <FormHelperText>{field.helpText}</FormHelperText>
    ) : null}
    {field.description && field.inputType?.startsWith("QUESTION") ? (
      <Text mt={2} color="gray.500" fontSize="sm">
        {field.description}
      </Text>
    ) : null}
  </FormControl>
);

export default FieldFrame;
